'use client';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../ui/tooltip';
import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';

interface TooltipPlaybackControlProps {
  action: 'play' | 'pause' | 'rewind';
  children: ReactNode;
}

export function TooltipPlaybackControl({
  action,
  children,
}: TooltipPlaybackControlProps) {
  const { t } = useTranslation();
  const tooltipKey = `tooltip.playback.${action}`;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          //   className='w-32'
          sideOffset={8}
          side='top'
          variant='zinc'
        >
          <div className='w-full m-2'>
            <div className='space-y-1'>
              <span className='text-sm'>{t(tooltipKey)}</span>
            </div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
